export class WeekdayModel {
  day: string
  open: string
  close: string
  is_close: boolean
  is_24_hours: boolean
  offtime_init : string
  offtime_end : string
  label: string

  constructor(obj: any = null) {
    this.day = obj?.day
    this.open = obj?.open
    this.close = obj?.close
    this.is_close = obj?.is_open
    this.is_24_hours = obj?.is_24_hours
    this.offtime_init = obj?.offtime_init
    this.offtime_end = obj?.offtime_end
    this.label = obj?.label
  }
}

export class ScheduleModel {
  [key: string]: any;
  monday: WeekdayModel;
  tuesday: WeekdayModel;
  wednesday: WeekdayModel;
  thursday: WeekdayModel;
  friday: WeekdayModel;
  saturday: WeekdayModel;
  sunday: WeekdayModel;

  constructor(obj: any = null) {
    this.monday = new WeekdayModel(obj?.monday)
    this.tuesday = new WeekdayModel(obj?.tuesday)
    this.wednesday = new WeekdayModel(obj?.wednesday)
    this.thursday = new WeekdayModel(obj?.thursday)
    this.friday = new WeekdayModel(obj?.friday)
    this.saturday = new WeekdayModel(obj?.saturday)
    this.sunday = new WeekdayModel(obj?.sunday)
  }
}
